import { EUserStatus, EUserType } from '../enums/user-role.enum';

export interface IUser {
  readonly id: string;
  firstName: string;
  lastName: string;
  phoneCode: string;
  phoneCountryCode: string;
  phoneNumber: string;
  email: string;
  role: string;
  status: EUserStatus;
  type: EUserType;
  lang: string;
  avatar: string;
  acceptedTerms: boolean;
  tfaEnabled: boolean;
  created: Date;
  acceptedPrivacyPolicy: boolean;
  permissions?: string[];
  countryCode?: string;
  tier?: number;
  monthlyWithdrawalLimit?: number;
  dailyWithdrawalLimit?: number;
  kycApplicantId?: string;
  ipAddress?: string;
  isBlocked?: boolean;
  isWithdrawalBlocked?: boolean;
  accountId?: string;
}

export interface IAdminUser {
  id: string;
  firstName: string;
  lastName: string;
  phoneCode: string;
  phoneCountryCode: string;
  phoneNumber: string;
  email: string;
  role: string;
  avatar: string;
}

export class UserModel implements IUser {
  readonly id!: string;
  firstName!: string;
  lastName!: string;
  phoneCode!: string;
  phoneCountryCode!: string;
  phoneNumber!: string;
  email!: string;
  role!: string;
  status!: EUserStatus;
  type!: EUserType;
  lang!: string;
  avatar!: string;
  acceptedTerms!: boolean;
  tfaEnabled!: boolean;
  created!: Date;
  acceptedPrivacyPolicy!: boolean;
  permissions?: string[];
  countryCode!: string;
  tier!: number;
  monthlyWithdrawalLimit!: number;
  dailyWithdrawalLimit!: number;
  kycApplicantId!: string;
  ipAddress!: string;
  isBlocked: boolean | undefined;
  isWithdrawalBlocked: boolean | undefined;
  accountId?: string;

  constructor(params: IUser) {
    if (params) {
      this.id = params?.id;
      this.firstName = params?.firstName || '';
      this.lastName = params?.lastName || '';
      this.phoneCode = params?.phoneCode || '';
      this.phoneCountryCode = params?.phoneCountryCode || '';
      this.phoneNumber = params?.phoneNumber || '';
      this.email = params?.email || '';
      this.role = params?.role || '';
      this.status = params?.status || '';
      this.type = params?.type;
      this.lang = params?.lang || '';
      this.avatar = params?.avatar || '';
      this.acceptedTerms = params?.acceptedTerms || false;
      this.tfaEnabled = params?.tfaEnabled || false;
      this.created = params?.created;
      this.acceptedPrivacyPolicy = params?.acceptedPrivacyPolicy || false;
      this.permissions = params?.permissions || [];
      this.countryCode = params?.countryCode || '';
      this.tier = params?.tier || 0;
      this.monthlyWithdrawalLimit = params?.monthlyWithdrawalLimit || 0;
      this.dailyWithdrawalLimit = params?.dailyWithdrawalLimit || 0;
      this.kycApplicantId = params?.kycApplicantId || '';
      this.ipAddress = params?.ipAddress || '';
      this.isBlocked = params?.isBlocked || undefined;
      this.isWithdrawalBlocked = params?.isWithdrawalBlocked || undefined;
      this.accountId = params?.accountId || '';
    }
  }
}

export type IUserList = {
  items: Omit<UserModel, 'permissions'>[];
  total: number;
};

export type IUsersBalanceList = {
  [key: string]: string;
};

export interface IUserResetPassword {
  newPassword: string;
  oldPassword: string;
}

export interface IUserForgotConfirm {
  password: string;
  token: string;
}

export interface IIpRecord {
  action: string;
  ipAddress: string;
  created: string;
  ipCountry?: string;
}

export interface IIpList {
  items: IIpRecord[];
  total: number;
}
